import { BeCountView, BeRow, BeScrollBar, BeStatusStrip } from "@beos-css/react/index.ts";
import { useState } from "react";

export function CountViewDemo() {
	const [sbH, setSbH] = useState(25);

	return (
		<section id="demo-count-view">
			<h2>Window status strip (BCountView)</h2>
			<p>
				Tracker's bottom-left "N items" cell (OpenTracker CountView.cpp), extended into a general status strip: fixed 63px cells like the
				original, or content-sized / greedy cells. "Busy" is the real 8x18 barber-pole bitmap (Tracker rsrc 1038) in its 10x10 recessed
				cell; type-ahead shows the muted match string.
			</p>
			<BeRow wrap gap="row">
				<BeCountView count={0} />
				<BeCountView count={1} />
				<BeCountView count={128} />
				<BeCountView count={42} busy />
				<BeCountView typeAhead="kernel_deb" width="auto" />
			</BeRow>
			<BeRow wrap gap="row">
				<BeStatusStrip className="demo-wide">
					<BeCountView count={7} busy />
					<BeCountView width="fill">Downloading BeOS 5 Personal Edition…</BeCountView>
					<BeCountView width="auto">512 KB free</BeCountView>
				</BeStatusStrip>
			</BeRow>
			<BeRow wrap gap="row">
				<BeStatusStrip className="demo-wide">
					<BeCountView count={7} />
					<BeScrollBar orientation="horizontal" value={sbH} max={100} proportion={0.35} onChange={setSbH} label="Strip scroll bar" />
				</BeStatusStrip>
			</BeRow>
		</section>
	);
}
